<div nz-row>
  <div nz-col nzSpan="16" nzOffset="4" style="text-align: center" class="header-report">
    <h1 class="report-title">
      <h2 class="upload-title">
        <strong>Diagnostic financiar</strong>
      </h2>

      <div class="report-info c-bg-multi">
        <div>
          <p [innerHTML]="bodyContent"></p>
          <nz-spin [nzSpinning]="!loadingPage" class="custom-spin"></nz-spin>
        </div>
        <!-- <div>
          <span>2</span>
          <p>
            {{ "second_message" | translate }}
          </p>
        </div> -->
      </div>
      <br />
    </h1>
  </div>
</div>
